// extracted by mini-css-extract-plugin
export default {"bg":"PFkO7r","inlineContent":"HT5ybB","pageWrapper":"dBAkHi"};